import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const PageHeader = styled.section`
  height: 300px;
  background: linear-gradient(rgba(220, 38, 38, 0.8), rgba(185, 28, 28, 0.8)), url("/images/oth_hdr_bg.webp");
  background-size: cover;
  background-position: center;
  display: flex;
  align-items: center;
  color: white;

  h1 {
    color: white;
    font-size: 3rem;
    text-align: center;
    width: 100%;
  }

  @media (max-width: 768px) {
    height: 200px;
    h1 {
      font-size: 2rem;
    }
  }
`;

const ContentSection = styled.section`
  padding: 80px 0;
  background: white;

  .content-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
    align-items: center;
    margin-bottom: 4rem;

    @media (max-width: 768px) {
      grid-template-columns: 1fr;
      gap: 2rem;
    }
  }

  .content-text {
    h2 {
      color: #dc2626;
      margin-bottom: 1.5rem;
    }

    p {
      color: #666;
      line-height: 1.8;
      margin-bottom: 1rem;
    }
  }

  .content-image {
    img {
      width: 100%;
      height: auto;
      border-radius: 10px;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
    }
  }
`;

const StatsSection = styled.section`
  padding: 80px 0;
  background: #f8f9fa;

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 2rem;
  }

  .stat-card {
    background: white;
    padding: 2rem;
    text-align: center;
    border-radius: 10px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);

    .stat-number {
      font-size: 3rem;
      font-weight: bold;
      color: #dc2626;
      margin-bottom: 0.5rem;
    }

    .stat-label {
      color: #666;
      font-weight: 500;
    }
  }
`;

const About = () => {
  const stats = [
    { number: "100+", label: "Happy Customers" },
    { number: "24/7", label: "Service Available" },
    { number: "50+", label: "Tyre Brands" },
    { number: "2+", label: "Years Experience" },
  ];

  return (
    <>
      <PageHeader>
        <div className="container">
          <motion.h1
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}>
            About Us
          </motion.h1>
        </div>
      </PageHeader>

      <ContentSection>
        <div className="container">
          <motion.div
            className="content-grid"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}>
            <div className="content-text">
              <h2>Welcome to Ausgrip Tyres</h2>
              <p>
                Our competitive advantage is not being tied to any one particular brand. Supporting major tyre brands ensuring constant supply &
                customer choice, with several alternatives achieving the best possible value for any application, Ausgrip Tyres is well placed to
                assist customers in selecting the right tyre to satisfy all tyre needs.
              </p>
              <p>
                Offering a focused range of truck and trailer tyres for heavy vehicles and commercial fleets, with options to suit linehaul, metro
                delivery, and off-highway applications.
              </p>
              <p>
                Quality truck tyres at the best prices in Australia. We fit and support tyres for rigid trucks, prime movers, trailers, and road
                trains. Our team of professional fitters will have your new tyres fitted and balanced promptly.
              </p>
            </div>
            <div className="content-image">
              <img
                src="/images/welc_pic.webp"
                alt="About Ausgrip Tyres"
              />
            </div>
          </motion.div>

          <motion.div
            className="content-grid"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}>
            <div className="content-image">
              <img
                src="/images/tyre.webp"
                alt="Our Services"
              />
            </div>
            <div className="content-text">
              <h2>Our Mission</h2>
              <p>
                To provide exceptional truck tyre solutions with unmatched customer service, competitive pricing, and reliable products that keep
                Australia's transport industry moving safely and efficiently.
              </p>
              <h2>Our Vision</h2>
              <p>
                To become Australia's most trusted name in commercial tyre services, known for our expertise, reliability, and commitment to customer
                satisfaction.
              </p>
              <h2>Why Choose Ausgrip Tyres?</h2>
              <p>
                With our extensive experience, wide range of quality products, and commitment to excellence, we deliver solutions that meet your
                specific needs while providing outstanding value for money.
              </p>
            </div>
          </motion.div>
        </div>
      </ContentSection>

      <StatsSection>
        <div className="container">
          <div className="section-title">
            <h2>Our Achievements</h2>
            <p>Numbers that speak for our commitment to excellence</p>
          </div>

          <div className="stats-grid">
            {stats.map((stat, index) => (
              <motion.div
                key={index}
                className="stat-card"
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                viewport={{ once: true }}>
                <div className="stat-number">{stat.number}</div>
                <div className="stat-label">{stat.label}</div>
              </motion.div>
            ))}
          </div>
        </div>
      </StatsSection>
    </>
  );
};

export default About;
